// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { VehicleMonitoringAreaId } from './VehicleMonitoringAreaId'
import {
  VehicleMonitoringAreaNavigation,
  VehicleMonitoringAreaNavigationIcon,
} from './VehicleMonitoringAreaNavigation'
import { VehicleMonitoringAreaRoutes } from './VehicleMonitoringAreaRoutes'

const LazyVehicleMonitoringComponent = lazy(
  () => import('./VehicleMonitoringArea'),
)

const VehicleMonitoringComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleMonitoringComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleMonitoringArea = {
  id: VehicleMonitoringAreaId,
  Icon: VehicleMonitoringAreaNavigationIcon,
  NavigationComponent: VehicleMonitoringAreaNavigation,
  route: {
    path: VehicleMonitoringAreaRoutes.route,
    component: VehicleMonitoringComponent,
  },
}
